<template>
    <v-dialog width="300px" v-model="showModal" persistent>
        <div class="ContainerModal white px-3 pt-5 pb-3">
            <div class="HeaderModal text-start pb-3 px-2" v-if="ifTitle">
                <span class="title font-weight-bold">{{ Title }}</span>
            </div>
            <div class="subheading font-weight-medium text-start py-3 px-2" v-if="ifSubheadingTop">
                <span>{{ SubheadingTop }}</span>
            </div>
            <div class="icon text-center py-3" v-if="ifIcon">
                <v-icon class="icon-size">{{ Icon }}</v-icon>
            </div>
            <div class="subheading font-weight-medium text-start py-3 px-2" v-if="ifSubheadingBottom">
                <span>{{ SubheadingBottom }}</span>
            </div>
            <v-layout class="oneBtn font-weight-regular text-start py-3" v-if="ifOneBtn">
                <v-btn class="white--text btn-sucess w-100 ma-0"  @click="$emit('btnUm')">{{ TextOneBtn }}</v-btn>
            </v-layout>
            <div class="twoBtn font-weight-regular py-3 px-1" v-if="ifTwoBtn">
                <v-btn text class="btn-error" @click="$emit('btnUm')">{{ TextFirstBtn }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn class="white--text btn-sucess"  @click=" $emit('btnDois')">{{ TextSecondBtn }}</v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>

export default {
    props: {
        showModal: Boolean,
        ifTitle: Boolean,
        Title: String,
        ifSubheadingTop: Boolean,
        SubheadingTop: String,
        ifIcon: Boolean,
        Icon: String,
        ifSubheadingBottom: Boolean,
        SubheadingBottom: String,
        ifOneBtn: Boolean,
        TextOneBtn: String,
        ifTwoBtn: Boolean,
        TextFirstBtn: String,
        TextSecondBtn: String
    }
}
</script>

<style scoped>
.icon-size{
    font-size: 70px;
    /* transform: rotate(46deg); */
}

.twoBtn{
    display: flex;
}

</style>